import React, { Component } from 'react';
class App extends Component {
  render() {
    return (
      <p>Hello world!</p>
    );
  }
}
export default App;